import { queryOptions } from "@tanstack/react-query";
import { experienceApi } from "@/lib/api";

export type Jtbd = {
  id: string;
  name: string;
  description: string;
  tools: string[];
  llm_instructions: string;
  example_prompts: string[];
  services: string[];
};

type JtbdsResponse = {
  jtbds: Jtbd[];
};

const fetchJtbds = async (): Promise<JtbdsResponse> => {
  const res = await experienceApi.get<JtbdsResponse>("/api/onboarding/jtbds");
  return res.data;
};

export const jtbdsQueryOptions = () =>
  queryOptions({
    queryKey: ["onboarding", "jtbds"] as const,
    queryFn: fetchJtbds,
    staleTime: Number.POSITIVE_INFINITY,
  });
